import { useState } from 'react';

import FeedbackForm from './feedback_form';
import UserPanelForm from './user_panel_form';
import FeedbackConfirmation from './feedback_confirmation';

const FeedbackCapture = ({ name }) => {
  const [formStage, setFormStage] = useState(1);

  if (formStage === 3) return <FeedbackConfirmation />;

  return (
    <>
      {formStage === 1 ? (
        <FeedbackForm setFormStage={setFormStage} />
      ) : (
        <UserPanelForm setFormStage={setFormStage} userName={name} />
      )}
    </>
  );
};

export default FeedbackCapture;
